import uniq from 'lodash/uniq';
import * as React from 'react';
import isEqual from 'react-fast-compare';
import { PriceType } from '../../classes/price-type';
import { CartSeat, Seat, SeatStyle, SeatZone } from '../../classes/seat';
import { SeatingOptionGroup } from '../../classes/seating-option';
import { IPriceRangeModel } from '../../filter/reducers/filter-reducers';
import SeatGroupPath from './seat-group-path';
import SeatPath from './seat-path';



interface ISeatPaths {
    seats: Array<Seat>;
    selectedSeats: Array<Seat>;
    seatStyles: Array<SeatStyle>;
    dispatch: any;
    levelPricing: Array<SeatZone>;
    selectedPriceTypes: Array<PriceType>;
    selectedSpecialSeatingFilter: Array<SeatingOptionGroup>;
    cartSeats: Array<CartSeat>;
    priceRangeModel: IPriceRangeModel;
    mapDragging: boolean;
    isExchange: boolean;
    loadedExchangePricing: boolean;

    hoveredSeatId: string;
    mouseOverSeat: (seats: Array<Seat>, xPos: number, yPos: number) => void;
    mouseOutSeat: () => void;
    isChrome: boolean;

    usingForceMultipleSeats: boolean;
}

class SeatPaths extends React.Component<ISeatPaths, any> {
    private singleSeats: Array<Seat>;
    private seatsWithSamePaths: Array<Seat>;
    private seatGroupIds: Array<string>;

    constructor(props) {
        super(props);
        let seatWithPaths = props.seats.filter(seat => {
            return seat.svgPath !== null;
        });

        this.seatsWithSamePaths = seatWithPaths.filter(seat => {
            return seatWithPaths.filter(s => s.svgPathId === seat.svgPathId).length > 1;
        });

        this.seatGroupIds = uniq(this.seatsWithSamePaths.map(path => path.svgPathId));
        if (this.props.isChrome) {
            this.seatGroupIds = this.seatGroupIds.reverse();
        }

        this.singleSeats = seatWithPaths.filter(seat => {
            return seatWithPaths.filter(s => s.svgPathId === seat.svgPathId).length == 1;
        });
    }

    shouldComponentUpdate(nextProps: ISeatPaths, nextState) {
        return this.props.priceRangeModel.minPrice !== nextProps.priceRangeModel.minPrice
            || this.props.priceRangeModel.maxPrice !== nextProps.priceRangeModel.maxPrice
            || ((this.props.selectedSeats.length == 0) ? (nextProps.selectedSeats.length > 0 ? true : false)
                : (nextProps.selectedSeats.length == 0 || this.props.selectedSeats[0].seatId !== nextProps.selectedSeats[0].seatId))
            || this.props.selectedSpecialSeatingFilter.length !== nextProps.selectedSpecialSeatingFilter.length
            || this.props.selectedPriceTypes.length !== nextProps.selectedPriceTypes.length
            || this.props.loadedExchangePricing !== nextProps.loadedExchangePricing
            || !isEqual(this.props, nextProps);
    }

    render() {
        return <g>
            {
                this.singleSeats.map(seat => {
                    return <SeatPath dispatch={this.props.dispatch}
                        seat={seat}
                        key={seat.seatId}
                        selectedSeat={this.props.selectedSeats.length > 0 ? this.props.selectedSeats[0] : null}
                        levelPricing={this.props.levelPricing}
                        selectedPriceTypes={this.props.selectedPriceTypes}
                        selectedSpecialSeatingFilter={this.props.selectedSpecialSeatingFilter}
                        lowerPrice={this.props.priceRangeModel.minPrice}
                        upperPrice={this.props.priceRangeModel.maxPrice}
                        mouseOutSeat={this.props.mouseOutSeat}
                        mouseOverSeat={this.props.mouseOverSeat}
                        mapDragging={this.props.mapDragging}
                        cartSeats={this.props.cartSeats}
                        seatStyles={this.props.seatStyles}
                        seatHovered={this.props.hoveredSeatId === seat.seatId}
                        isExchange={this.props.isExchange}
                        loadedExchangePricing={this.props.loadedExchangePricing}
                    />
                })
            }
            {
                this.seatGroupIds.map((svgPathId) => {
                    var groupSeats = this.seatsWithSamePaths.filter(seat => seat.svgPathId === svgPathId);
                    var sortedSeats = [...groupSeats].sort((a, b) => {
                        return (b.tessituraSeat.isAvailable ? 1 : 0) - (a.tessituraSeat.isAvailable ? 1 : 0);
                    });
                    return <SeatGroupPath dispatch={this.props.dispatch}
                        seats={sortedSeats}
                        key={svgPathId}
                        cartSeats={this.props.cartSeats}
                        selectedSeats={this.props.selectedSeats}
                        levelPricing={this.props.levelPricing}
                        selectedPriceTypes={this.props.selectedPriceTypes}
                        lowerPrice={this.props.priceRangeModel.minPrice}
                        upperPrice={this.props.priceRangeModel.maxPrice}
                        isExchange={this.props.isExchange}
                        mouseOutGroup={this.props.mouseOutSeat}
                        mouseOverGroup={this.props.mouseOverSeat}
                        mapDragging={this.props.mapDragging}
                    />
                })
            }

        </g>
    }

    computeSeatHoverPositionY(seat: Seat) {
        var pos = document.getElementById('seat-' + seat.seatId).getBoundingClientRect();
        var yPos = window.innerHeight / 2 - pos.bottom - pos.height;

        if (yPos > 0) {
            yPos = yPos + (pos.height);
        }

        return yPos;
    }

    computeSeatHoverPositionX(seat: Seat) {
        var pos = document.getElementById('seat-' + seat.seatId).getBoundingClientRect();

        return pos.left + (pos.width / 2);
    }
}

export default SeatPaths;